
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#bac1cc","stroke-linecap":"round","stroke-width":"1.5","data-name":"vuesax/broken/gallery-add"}},[_c('path',{attrs:{"d":"M11.254 7.493a2.512 2.512 0 102.512 2.512","stroke-linejoin":"round"}}),_c('path',{attrs:{"data-name":"Vector","d":"M2.512 16.172v2.525c0 6.28 2.5 8.791 8.742 8.791h7.493c6.244 0 8.742-2.512 8.742-8.791v-6.28M16.327 2.512h-5.024c-6.279 0-8.791 2.512-8.791 8.791","stroke-linejoin":"round"}}),_c('path',{attrs:{"data-name":"Vector","d":"M19.639 6.25h6.908M23.125 9.734V2.826"}}),_c('path',{attrs:{"data-name":"Vector","d":"M3.353 23.7l6.155-4.157a2.8 2.8 0 013.3.176l.412.364a2.771 2.771 0 003.521 0l5.191-4.484a2.771 2.771 0 013.521 0l2.035 1.758","stroke-linejoin":"round"}})])])
          )
        }
      }
    